export enum ModalTemplates {
  Default = 'default',
  Confirmation = 'confirmation',
  SessionExpired = 'session-expired',
  InfoImagesFlex = 'info-images-flex',
  InfoOnlyText = 'info-only-text',
}
